import { render, staticRenderFns } from "./PlaylistAttachmentPicker.vue?vue&type=template&id=557fb03a&scoped=true"
import script from "./PlaylistAttachmentPicker.vue?vue&type=script&lang=js"
export * from "./PlaylistAttachmentPicker.vue?vue&type=script&lang=js"
import style0 from "./PlaylistAttachmentPicker.vue?vue&type=style&index=0&id=557fb03a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557fb03a",
  null
  
)

export default component.exports